import React, { useEffect, useRef } from "react";
import "./SupportCvanto.scss";
import DynamicHeader from "../../Header/DynamicHeader";

const SupportCvanto = () => {
  const rootRef = useRef(null);

  useEffect(() => {
    const rootEl = rootRef.current;
    if (!rootEl) return;
    const items = Array.from(rootEl.querySelectorAll(".js-reveal"));
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("is-visible");
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: "0px 0px -10% 0px" }
    );
    items.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);

  return (
    <>
      <DynamicHeader
        title="Підтримати Cvanto"
        variant="glass"
        size="regular"
        showBack
        withSpacer
      />

      <div className="support" ref={rootRef}>
        <div className="support__card js-reveal" data-reveal="hero">
          <h1 className="support__title">Підтримати Cvanto</h1>

          <p className="support__desc">
            Ваша підтримка допомагає розвивати українську соціально-комерційну
            платформу: інфраструктура, безпека, модерація, нові функції та
            стабільність сервісу.
          </p>

          {/* */}
          <button className="support__cta support__cta--disabled" disabled>
            Підтримати через Monobank
          </button>
        </div>
      </div>
    </>
  );
};

export default SupportCvanto;
